import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';

export interface ProceedConfirmationComponentData {
  title: string;
  message1: string;
  message2: string;
  cancelCaption: string;
  proceedCaption: string;
}

@Component({
    selector: 'app-proceed-confirmation',
    templateUrl: './proceed-confirmation.component.html',
    styleUrls: ['./proceed-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProceedConfirmationComponent {
  static readonly componentName = 'ProceedConfirmationComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  constructor(@Inject(MAT_DIALOG_DATA) 
    public data: ProceedConfirmationComponentData
    ) { }
}